import React from 'react';
import classnames from 'classnames';

interface InAppSidebarItemProps {
    item?: any;
    onClick?(e: React.MouseEvent): void;
    active?: boolean;
    tagActive?: string;
}

export const InAppSidebarItem = function (props: InAppSidebarItemProps) {
    let { item, active, onClick, tagActive } = props;

    let activeItem = false;

    if (active && tagActive?.includes(item)) {
        activeItem = true;
    }

    if (!active && !tagActive && item === 'All') {
        activeItem = true;
        tagActive = item;
    }

    return (
        <div className={classnames('sidebar-item', activeItem && 'active')} onClick={onClick}>
            <span className='in-app-videos__sidebar-item'> {item} </span>
        </div>
    );
};